import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Flex } from 'reflexbox'
import { Tab } from 'react-toolbox/lib/tabs'
import { List, ListItem } from 'react-toolbox/lib/list'

import withLoading from 'containers/Async/AsyncProgressBarHoc'
import TabLabel from 'components/fulcrum/tabLabel/TabLabel'
import Tabs from './Tabs'
import TabContent from './TabContent'
import {
  UPDATE_PARTNER_SITE_FILTER,
  UPDATE_PRODUCT_HIERARCHY_FILTER,
  UPDATE_PRODUCT_HIERARCHY_SOURCE,
  ProductHierarchyEnum,
} from './constants'
import {
  updateProductHierarchyValue,
  updateProductHierarchyFilter,
  updateProductHierarchyTabIndex,
  toggleProductHierarchyContent,
} from './actions'
import {
  productHierarchyListSelector,
  productHierarchyValueSelector,
} from './selectors'

import styles from './styles.scss'

const EnhancedList = withLoading(List)([
  UPDATE_PARTNER_SITE_FILTER,
  UPDATE_PRODUCT_HIERARCHY_FILTER,
  UPDATE_PRODUCT_HIERARCHY_SOURCE
])

const mapStateToProps = (state) => {
  // console.log(state)
  return {
    index: state.uiState.projectCreate.productHierarchy.tabIndex,
    isCollapse: state.uiState.projectCreate.productHierarchy.isCollapse,
    showContent: state.uiState.projectCreate.productHierarchy.showContent,
    productHierarchyValue: productHierarchyValueSelector(state),
    productHierarchyList: productHierarchyListSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleProductHierarchyContent: () => dispatch(toggleProductHierarchyContent()),
    updateProductHierarchyTabIndex: (type) => dispatch(updateProductHierarchyTabIndex(type)),
    updateValue: (type, value) => dispatch(updateProductHierarchyValue(type, value)),
    updateFilter: (parent, child, value) => dispatch(updateProductHierarchyFilter(parent, child, value)),
  }
}

class ProductHierarchyTabs extends Component {
  updateTab = (type) => {
    return () => this.props.updateProductHierarchyTabIndex(type)
  }

  updateFilter = (parent, child, ids) => {
    return () => {
      return(this.props.updateFilter(parent, child, ids))
    }
  }

  updateValue = (type) => {
    return (value) => {
      return(this.props.updateValue(type, value))
    }
  }

  generateListItems(parent, child) {
    const { productHierarchyList, productHierarchyValue } = this.props
    const query = productHierarchyValue(parent)
    const items = productHierarchyList(parent)
    const regexp = new RegExp(query, 'i')
    return Object.keys(items)
      .filter(value => value.match(regexp))
      .map((value) => (
        <ListItem
          key={value}
          caption={value}
          onClick={this.updateFilter(parent, child, items[value])}
        />
      ))
  }

  getTabLabel(type) {
    const { productHierarchyList } = this.props
    const items = productHierarchyList(type)
    let tabLabel = type.label
    const labels = Object.keys(items)
    if (Object.keys(labels).length === 1)
      tabLabel = (
        <TabLabel tabLabel={tabLabel} tabIconName='check_circle' tabChosenValue={labels[0]}/>
      )
    return tabLabel
  }

  generateTabs() {
    const {
      isCollapse,
      showContent,
      productHierarchyValue,
      toggleProductHierarchyContent,
    } = this.props
    const keys = Object.keys(ProductHierarchyEnum)
    const tabs = keys.map((key, index, array) => {
      const parent = ProductHierarchyEnum[key]
      const child = ProductHierarchyEnum[array[index + 1]]
      return (
        <Tab
          theme={styles}
          key={parent.label}
          label={this.getTabLabel(parent)}
          onClick={this.updateTab(parent)}>
          <TabContent
            label={parent.label}
            onChange={this.updateValue(parent)}
            input={productHierarchyValue(parent)}
            showContent={showContent}
            collapse={isCollapse}
            onCollapseButtonClick={toggleProductHierarchyContent}>
            <EnhancedList selectable ripple>
              { this.generateListItems(parent, child) }
            </EnhancedList>
          </TabContent>
        </Tab>
      )
    })
    return tabs
  }

  render() {
    const {
      index,
    } = this.props
    return (
      <Tabs index={index}>
        { this.generateTabs() }
      </Tabs>
    )
  }
}

const withStyles = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withConnect,
  withStyles
)

export default enhance(ProductHierarchyTabs)
